(function () {
  angular.module("akitabox.ui.dialogs.document.archive", [
    "akitabox.core.constants",
    "akitabox.core.services.document",
    "akitabox.core.toast",
  ]);
})();
